import { useAuthenticatedUser } from "@ngt/online-patient-management-ui";
import { useEffect } from "react";
import { createSentryAnonymousUser } from "src/utilities/errors";
import * as Sentry from "@sentry/react";

const useSentryUser = () => {
    const [authenticatedUser,,] = useAuthenticatedUser();
    useEffect(() => {
        // no user, clear sentry user.
        if (!authenticatedUser) {
            // set Sentry User back to anonymous.
            Sentry.setUser(createSentryAnonymousUser());
            return;
        }
        // user, set sentry user.
        Sentry.setUser({
            id: authenticatedUser.userName,
            username: authenticatedUser.userName,
            fullName: authenticatedUser.displayName,
            authenticated: true
        })
        return () => {
            // set Sentry User back to anonymous.
            Sentry.setUser(createSentryAnonymousUser());
        }
    }, [authenticatedUser])
}

export default useSentryUser;